import { Box, Tooltip, Typography } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import dayjs from 'dayjs';

const fmt = d => (d ? dayjs(d).format('DD.MM.YYYY HH:mm') : null);

const buildTooltip = state => {
  if (!state) return '';
  if (state.isSuppressed) {
    const since = fmt(state.lastHardBounceAt || state.firstHardBounceAt);
    const err = state.lastErrorMessage ? ` – ${state.lastErrorMessage}` : '';
    return `Adresse als nicht zustellbar gesperrt${since ? ` seit ${since}` : ''}${err}`;
  }
  const since = fmt(state.lastSoftBounceAt || state.firstSoftBounceAt);
  const err = state.lastErrorMessage ? ` – ${state.lastErrorMessage}` : '';
  return `Letzter Soft-Bounce${since ? ` am ${since}` : ''}${err}`;
};

// Inline icon (+ optional label) representing the per-address bounce state.
// `state` must come from a backend list response or the EmailBounceState hook
// and at minimum contain isSuppressed + the relevant timestamps/error.
const EmailBounceStateIndicator = ({
  state,
  showSoftBounces = false,
  iconSize = 'small',
  label,
  sx,
}) => {
  if (!state) return null;
  const isHard = Boolean(state.isSuppressed);
  const isSoftOnly = !isHard && Boolean(state.softBounceCount);
  if (!isHard && (!isSoftOnly || !showSoftBounces)) return null;

  const tooltip = buildTooltip(state);
  const Icon = isHard ? ReportProblemIcon : WarningAmberIcon;
  const color = isHard ? 'error.main' : 'warning.main';

  return (
    <Tooltip title={tooltip}>
      <Box
        component='span'
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color, ...sx }}
      >
        <Icon fontSize={iconSize} sx={{ color }} />
        {label && (
          <Typography component='span' variant='caption' sx={{ color }}>
            {label}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default EmailBounceStateIndicator;
